/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Overrides_TitleInputs */

const fr_style_overrides_title = /** @type {(inputs: Style_Overrides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisation CSS avancée`)
};

const en_style_overrides_title = /** @type {(inputs: Style_Overrides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced CSS customization`)
};

/**
* | output |
* | --- |
* | "Advanced CSS customization" |
*
* @param {Style_Overrides_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_title = /** @type {((inputs?: Style_Overrides_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_title(inputs)
	return en_style_overrides_title(inputs)
});